import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TextMaskModule } from 'angular2-text-mask';
import { NgxCaptchaModule } from 'ngx-captcha';

import { LzPopupComponent } from './components/lz-popup/lz-popup.component';
import { LzPopupService } from './services/lz-popup.service';

import { SharingModule } from '../lz-sharing/sharing.module';

@NgModule({
   declarations: [
      LzPopupComponent
   ],
   imports: [
      CommonModule,
      TranslateModule,
      SharingModule,
      FormsModule,
      ReactiveFormsModule,
      TextMaskModule,
      NgxCaptchaModule
   ],
   entryComponents: [
         LzPopupComponent
   ],
   providers: [
      LzPopupService
   ]
})

export class LzPopupModule { }
